module.exports = __webpack_public_path__ + "e9435de829a9f32b47166cc9ab24c7dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/ball.svg
// module id = 179
// module chunks = 0